import {
  CnpjFormField,
  FloatingFormItem,
  InputText,
  InputDecimal,
} from '@/components/_common';
import { InvoiceEmissionGoal } from '@/core/domain/invoice/invoices/invoices.enums';
import { Card, Row, Col, Input, Form, FormInstance } from 'antd';
import { useInvoiceFormContext } from '../../../InvoiceFormProvider';
import { useDefaultEmptyFieldError } from '@/hooks';
import TaxeIpiCstSelect from '@/components/_common/TaxeIpiCstSelect';
import { InvoicePartFormValues } from '../InvoicePartForm.types';

interface Props {
  form: FormInstance<InvoicePartFormValues>;
}

const InvoicePartIpiForm: React.FC<Props> = ({ form }) => {
  const formValues = Form.useWatch([], form);
  const required = useDefaultEmptyFieldError();

  const {
    invoice: { data: invoice },
    disabledFields,
  } = useInvoiceFormContext();

  // TODO: Verificar com a SEFAZ a validação de campos corretos
  // const hiddenFields = useCallback(
  //   (rules: string[]) => {
  //     if (cstType === 1 && rules && ipiCst) {
  //       return !rules.includes(ipiCst);
  //     } else if (ipiCst && rules) {
  //       return !rules.includes(ipiCst);
  //     }
  //     return false;
  //   },
  //   [ipiCst],
  // );

  return (
    <Form form={form} preserve={false} disabled={disabledFields}>
      <Card title="IPI" type="inner" style={{ marginBottom: 24 }}>
        <Row gutter={[24, 16]}>
          <Col xs={24} md={12} lg={8}>
            <FloatingFormItem label="CST" name={['itemTaxes', 'ipi', 'ipiCst']}>
              <TaxeIpiCstSelect allowClear />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} lg={8}>
            <CnpjFormField
              label="CNPJ do produtor da mercadoria"
              fieldName={['itemTaxes', 'ipi', 'ipiProducerCnpj']}
              required={false}
              disabled={disabledFields}
            />
          </Col>

          <Col xs={24} sm={12} lg={8}>
            <FloatingFormItem
              label="Cód. enquadramento"
              name={['itemTaxes', 'ipi', 'ipiLegalClassificationCode']}
            >
              <InputText onlyNumber />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} lg={8}>
            <FloatingFormItem
              label="Alíquota"
              name={['itemTaxes', 'ipi', 'ipiAliquot']}
            >
              <InputDecimal fractions={4} max={100} />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} lg={8}>
            <FloatingFormItem
              label="Base de cálculo"
              name={['itemTaxes', 'ipi', 'ipiBaseCalculation']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} lg={8}>
            <FloatingFormItem
              label="Valor"
              name={['itemTaxes', 'ipi', 'ipiValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>
        </Row>
      </Card>

      <Card title="Selo controle" type="inner" style={{ marginBottom: 24 }}>
        <Row gutter={[24, 16]}>
          <Col xs={24} sm={12} lg={8}>
            <FloatingFormItem
              label="Código"
              name={['itemTaxes', 'ipi', 'ipiControlSealCode']}
            >
              <Input maxLength={60} />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} lg={8}>
            <FloatingFormItem
              label="Quantidade"
              name={['itemTaxes', 'ipi', 'ipiControlSealQuantity']}
            >
              <InputText onlyNumber max={12} />
            </FloatingFormItem>
          </Col>
        </Row>
      </Card>

      <Card title="Unidade" type="inner" style={{ marginBottom: 24 }}>
        <Row gutter={[24, 16]}>
          <Col xs={24} sm={12} lg={8}>
            <FloatingFormItem
              label="Valor"
              name={['itemTaxes', 'ipi', 'ipiUnitValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} lg={8}>
            <FloatingFormItem
              label="Quantidade"
              name={['itemTaxes', 'ipi', 'ipiUnitQuantity']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>
        </Row>
      </Card>

      {invoice?.emissionGoal === InvoiceEmissionGoal.NFE_MERCHANDISE_RETURN && (
        <Card
          title="Imposto devolvido"
          type="inner"
          style={{ marginBottom: 24 }}
        >
          <Row gutter={[24, 16]}>
            <Col xs={24} sm={12} lg={8}>
              <FloatingFormItem
                label="% Mercadoria devolvida"
                name={['itemTaxes', 'ipi', 'returnedGoodsPercentage']}
                rules={
                  formValues?.itemTaxes?.ipi.returnedIpiValue
                    ? [required]
                    : undefined
                }
                getValueFromEvent={(value) => {
                  if (!value) {
                    form.setFields([
                      {
                        name: ['itemTaxes', 'ipi', 'returnedIpiValue'],
                        errors: [],
                      },
                    ]);
                  }
                  return value;
                }}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={12} lg={8}>
              <FloatingFormItem
                label="Valor ipi devolvido"
                name={['itemTaxes', 'ipi', 'returnedIpiValue']}
                rules={
                  formValues?.itemTaxes?.ipi.returnedGoodsPercentage
                    ? [required]
                    : undefined
                }
                getValueFromEvent={(value) => {
                  if (!value) {
                    form.setFields([
                      {
                        name: ['itemTaxes', 'ipi', 'returnedGoodsPercentage'],
                        errors: [],
                      },
                    ]);
                  }
                  return value;
                }}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>
          </Row>
        </Card>
      )}
    </Form>
  );
};

export default InvoicePartIpiForm;
